"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
// Packages

// Main Component
function Licensing(props) {
  var _props$licenses6, _props$licenses13, _props$licenses20;
  if (!props.licenses) return null;
  const scenario = () => {
    var _props$licenses, _props$licenses2, _props$licenses3;
    // If the MB isn't listed in GA use default licensing format
    if (!((_props$licenses = props.licenses) !== null && _props$licenses !== void 0 && _props$licenses.includes("GA")) && !((_props$licenses2 = props.licenses) !== null && _props$licenses2 !== void 0 && _props$licenses2.includes("GA TAO"))) {
      return "default";
    }
    // If the MB is only licensed in GA
    else if (((_props$licenses3 = props.licenses) === null || _props$licenses3 === void 0 ? void 0 : _props$licenses3.length) < 2) {
      var _props$licenses4;
      if ((_props$licenses4 = props.licenses) !== null && _props$licenses4 !== void 0 && _props$licenses4.includes("GA")) {
        return "ga-standard";
      } else {
        return "ga-tao";
      }
    }
    // If the MB is licensed in GA and other states
    else {
      var _props$licenses5;
      if ((_props$licenses5 = props.licenses) !== null && _props$licenses5 !== void 0 && _props$licenses5.includes("GA")) {
        return "ga-plus-standard";
      } else {
        return "ga-plus-tao";
      }
    }
  };
  switch (scenario()) {
    default:
      return /*#__PURE__*/_react.default.createElement("span", null, `Licensed in `, (_props$licenses6 = props.licenses) === null || _props$licenses6 === void 0 ? void 0 : _props$licenses6.map(licensedState => {
        var _props$licenses7, _props$licenses8, _props$licenses9, _props$licenses10, _props$licenses11, _props$licenses12;
        return /*#__PURE__*/_react.default.createElement("span", {
          key: licensedState
        }, `${licensedState}${((_props$licenses7 = props.licenses) === null || _props$licenses7 === void 0 ? void 0 : _props$licenses7.length) === 2 && ((_props$licenses8 = props.licenses) === null || _props$licenses8 === void 0 ? void 0 : _props$licenses8.indexOf(licensedState)) < ((_props$licenses9 = props.licenses) === null || _props$licenses9 === void 0 ? void 0 : _props$licenses9.length) - 1 ? " & " : ""}${((_props$licenses10 = props.licenses) === null || _props$licenses10 === void 0 ? void 0 : _props$licenses10.length) > 2 && ((_props$licenses11 = props.licenses) === null || _props$licenses11 === void 0 ? void 0 : _props$licenses11.indexOf(licensedState)) < ((_props$licenses12 = props.licenses) === null || _props$licenses12 === void 0 ? void 0 : _props$licenses12.length) - 1 ? ", " : ""}`);
      }));
    case "ga-standard":
      return /*#__PURE__*/_react.default.createElement("span", null, `Georgia Residential Mortgage Licensee # ${props.stateSpecificLicense}`);
    case "ga-tao":
      return /*#__PURE__*/_react.default.createElement("span", null, `GA Temporary Authority`);
    case "ga-plus-standard":
      return /*#__PURE__*/_react.default.createElement("span", null, `Licensed in `, (_props$licenses13 = props.licenses) === null || _props$licenses13 === void 0 ? void 0 : _props$licenses13.map(licensedState => {
        var _props$licenses14, _props$licenses15, _props$licenses16, _props$licenses17, _props$licenses18, _props$licenses19;
        return /*#__PURE__*/_react.default.createElement("span", {
          key: licensedState
        }, `${licensedState === "GA" ? "GA # " + props.stateSpecificLicense : licensedState}${((_props$licenses14 = props.licenses) === null || _props$licenses14 === void 0 ? void 0 : _props$licenses14.length) === 2 && ((_props$licenses15 = props.licenses) === null || _props$licenses15 === void 0 ? void 0 : _props$licenses15.indexOf(licensedState)) < ((_props$licenses16 = props.licenses) === null || _props$licenses16 === void 0 ? void 0 : _props$licenses16.length) - 1 ? " & " : ""}${((_props$licenses17 = props.licenses) === null || _props$licenses17 === void 0 ? void 0 : _props$licenses17.length) > 2 && ((_props$licenses18 = props.licenses) === null || _props$licenses18 === void 0 ? void 0 : _props$licenses18.indexOf(licensedState)) < ((_props$licenses19 = props.licenses) === null || _props$licenses19 === void 0 ? void 0 : _props$licenses19.length) - 1 ? ", " : ""}`);
      }));
    case "ga-plus-tao":
      return /*#__PURE__*/_react.default.createElement("span", null, `Licensed in `, (_props$licenses20 = props.licenses) === null || _props$licenses20 === void 0 ? void 0 : _props$licenses20.map((licensedState, i) => {
        var _props$licenses21, _props$licenses22, _props$licenses23;
        return /*#__PURE__*/_react.default.createElement("span", {
          key: `${licensedState}-${i}`
        }, `${licensedState === "GA TAO" ? "" : licensedState}${((_props$licenses21 = props.licenses) === null || _props$licenses21 === void 0 ? void 0 : _props$licenses21.length) > 2 && licensedState !== "GA TAO" && ((_props$licenses22 = props.licenses) === null || _props$licenses22 === void 0 ? void 0 : _props$licenses22.indexOf(licensedState)) < ((_props$licenses23 = props.licenses) === null || _props$licenses23 === void 0 ? void 0 : _props$licenses23.length) - 1 ? ", " : ""}`);
      }), /*#__PURE__*/_react.default.createElement("br", null), "GA Temporary Authority");
  }
}
Licensing.propTypes = {
  licenses: _propTypes.default.array.isRequired,
  /** Only applies to Georgia currently */
  stateSpecificLicense: _propTypes.default.string
};
Licensing.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Licensing",
  "props": {
    "licenses": {
      "description": "",
      "type": {
        "name": "array"
      },
      "required": true
    },
    "stateSpecificLicense": {
      "description": "Only applies to Georgia currently",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = Licensing;
exports.default = _default;